// import React, { useState, useRef, useEffect } from "react";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getPaginationRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
//   flexRender,
// } from "@tanstack/react-table";
// import { useReactToPrint } from "react-to-print";
// import * as XLSX from "xlsx";
// import { FaFileExcel, FaPrint, FaSearch } from "react-icons/fa";
// import { GrFormNext } from "react-icons/gr";
// import { GrFormPrevious } from "react-icons/gr";
// // ─── Design tokens ────────────────────────────────────────────────────────────
// const T = {
//   brown: "#5c3d11",
//   brownDark: "#3e2005",
//   orange: "#e07b2a",
//   bgHead: "#f0f4f8",    // clean cool-grey thead
//   borderHead: "#dde4ec",
//   borderCell: "#eef2f7",
//   textHead: "#3a5a7a",    // slate blue-grey header labels
//   textCell: "#1a1a1a",
//   rowHover: "#fdf6ee",
//   footerBg: "#faf3eb",    // dark brown — matches header
//   footerText: "#201403",    // warm gold text on brown
//   font: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// };

// // ─── CSS ──────────────────────────────────────────────────────────────────────
// const CSS = `



//   @media print {
//     .crt-toolbar, .crt-pagination { display: none !important; }
//     .crt-card { box-shadow: none !important; border: none !important; }
//     thead tr th {
//       background-color: ${T.brownDark} !important;
//       color: #fff !important;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//     }
//   }
// `;

// function InjectStyles() {
//   useEffect(() => {
//     const id = "crt-styles-v4";
//     if (!document.getElementById(id)) {
//       const el = document.createElement("style");
//       el.id = id; el.textContent = CSS;
//       document.head.appendChild(el);
//     }
//   }, []);
//   return null;
// }

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function isNumericValue(val) {
//   if (val === null || val === undefined || val === "") return false;
//   return !isNaN(Number(val)) && String(val).trim() !== "";
// }
// function isNumericColumn(data, accessorKey) {
//   if (!accessorKey) return false;
//   const s = data.filter(r => r[accessorKey] != null).slice(0, 3);
//   return s.length > 0 && s.every(r => isNumericValue(r[accessorKey]));
// }






// // ─── Component ────────────────────────────────────────────────────────────────
// export default function CommonReactTable({
//   columns, data, headerName,
//   showPagination = true,
//   showFooter = "false",
//   align = "right",
//   decimal,
//   showPrint = true,
//   showExcel = true,
//   excelFileName,

// }) {
//   const [globalFilter, setGlobalFilter] = useState("");
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [pagination, setPagination] = useState({
//     pageIndex: 0,
//     pageSize: showPagination ? 10 : (data?.length || 0),
//   });
//   const table = useReactTable({
//     data, columns,

//     state: { globalFilter, pagination },
//     onPaginationChange: setPagination,


//     onGlobalFilterChange: setGlobalFilter,
//     getCoreRowModel: getCoreRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//   });

//   const rows = table.getRowModel().rows;
//   const { pageIndex, pageSize } = pagination;
//   const tableRef = useRef(null);

//   const handlePrint = useReactToPrint({ contentRef: tableRef, documentTitle: excelFileName });


//   const handleExcelExport = () => {
//     const headerGroups = table.getHeaderGroups();
//     const leafColumns = table.getVisibleLeafColumns();
//     const rows = table.getRowModel().rows;

//     const maxDepth = headerGroups.length;

//     // 🧠 Step 1: Create empty matrix
//     const sheetMatrix = Array.from({ length: maxDepth }, () =>
//       Array(leafColumns.length).fill("")
//     );

//     // 🧠 Step 2: Fill headers with colSpan + rowSpan
//     headerGroups.forEach((group, rowIndex) => {
//       let colIndex = 0;

//       group.headers.forEach((header) => {
//         const colSpan = header.colSpan;
//         const rowSpan = header.isPlaceholder
//           ? 0
//           : header.subHeaders?.length
//             ? 1
//             : maxDepth - rowIndex;

//         const value = header.isPlaceholder
//           ? ""
//           : typeof header.column.columnDef.header === "string"
//             ? header.column.columnDef.header
//             : header.column.id;

//         if (!header.isPlaceholder) {
//           sheetMatrix[rowIndex][colIndex] = value;
//         }

//         colIndex += colSpan;
//       });
//     });

//     // 🧾 Step 3: Data rows
//     const dataRows = rows.map((row, rowIndex) =>
//       leafColumns.map((col) => {
//         if (col.id === "slNo") return rowIndex + 1;
//         const key = col.columnDef.accessorKey || col.id;
//         return row.original?.[key] ?? "";
//       })
//     );

//     const finalData = [...sheetMatrix, ...dataRows];

//     const ws = XLSX.utils.aoa_to_sheet(finalData);

//     // 🧩 Step 4: Apply merges (colSpan + rowSpan)
//     const merges = [];

//     headerGroups.forEach((group, rowIndex) => {
//       let colIndex = 0;

//       group.headers.forEach((header) => {
//         const colSpan = header.colSpan;
//         const rowSpan = header.isPlaceholder
//           ? 0
//           : header.subHeaders?.length
//             ? 1
//             : maxDepth - rowIndex;

//         if (colSpan > 1 || rowSpan > 1) {
//           merges.push({
//             s: { r: rowIndex, c: colIndex },
//             e: {
//               r: rowIndex + rowSpan - 1,
//               c: colIndex + colSpan - 1,
//             },
//           });
//         }

//         colIndex += colSpan;
//       });
//     });

//     ws["!merges"] = merges;

//     // 📏 Optional: Auto column width
//     ws["!cols"] = leafColumns.map(() => ({ wch: 20 }));

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Report");

//     XLSX.writeFile(wb, `${excelFileName || "export"}.xlsx`);
//   };


//   function rowsCount(col) {
//     let sum = 0;
//     const rdata = data; // use all rows
//     if (col?.FooterParamAction) {
//       const p = col.Footerparams?.split("-");
//       const p1 = rdata?.reduce((s, r) => s + (Number(r[p[0]]) || 0), 0);
//       const p2 = rdata?.reduce((s, r) => s + (Number(r[p[1]]) || 0), 0);
//       const p3 = rdata?.reduce((s, r) => s + (Number(r[p[2]]) || 0), 0);
//       if (col.FooterParamAction === "-") sum = p1 - p2 - p3;
//       else if (col.FooterParamAction === "/") sum = parseFloat(((p1 / p2) * 100).toFixed(1));
//       else sum = p1 + p2;
//     } else {
//       sum = rdata?.reduce((s, r) => s + (Number(r[col.accessorKey]) || 0), 0);
//     }
//     return !isNaN(sum) ? (decimal === "two" ? sum.toFixed(2) : sum) : "";
//   }

//   const totalRows = table.getFilteredRowModel().rows.length;
//   const allHeaders = table.getHeaderGroups();



//   function getLeafColumns(cols) {
//     let leaf = [];

//     cols.forEach(col => {
//       if (col.columns) {
//         leaf = leaf.concat(getLeafColumns(col.columns));
//       } else {
//         leaf.push(col);
//       }
//     });

//     return leaf;
//   }

//   const leafColumns = getLeafColumns(columns);

//   const numericColIds = new Set(
//     leafColumns
//       .filter(col => col.accessorKey && isNumericColumn(data, col.accessorKey))
//       .map(col => col.accessorKey)
//   );
//   const formatValue = (val) => {
//     if (val === null || val === undefined || val === "") {
//       return "-";
//     }
//     return val;
//   };
//   return (
//     <>
//       <InjectStyles />
//       <div>
//         <div className="crt-card">

//           <div
//             className="crt-toolbar"
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//               alignItems: "center",
//               width: "100%",
//             }}
//           >
//             <div
//               className="crt-toolbar-right mb-2"
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               <div
//                 className="search-container"

//               >
//                 <FaSearch className="crt-search-icon" style={{ marginRight: "6px" }} />
//                 <input
//                   value={globalFilter ?? ""}
//                   onChange={(e) => setGlobalFilter(e.target.value)}
//                   placeholder="Search..."
//                   className="crt-search"
//                   style={{
//                     border: "none",
//                     outline: "none",
//                   }}
//                 />
//               </div>

//               {showExcel && (
//                 <button
//                   type="button"
//                   className="print-tablebtn btn-success btn btn-sm"
//                   onClick={handleExcelExport}
//                 >
//                   <FaFileExcel size={14} />
//                 </button>
//               )}

//               {showPrint && (
//                 <button
//                   type="button"
//                   className="print-tablebtn btn-primary btn btn-sm"
//                   onClick={handlePrint}
//                 >
//                   <FaPrint size={14} />
//                 </button>
//               )}
//             </div>
//           </div>


//           {/* Table */}
//           <div className="table-responsive">
//             <table ref={tableRef} className="newreporttable table table-bordered table-hovered  ">



//               <thead>
//                 {table.getHeaderGroups().map(headerGroup => (
//                   <tr key={headerGroup.id}>
//                     {headerGroup.headers.map(header => (
//                       <th key={header.id} colSpan={header.colSpan}>
//                         {header.isPlaceholder
//                           ? null
//                           : flexRender(header.column.columnDef.header, header.getContext())}
//                       </th>
//                     ))}
//                   </tr>
//                 ))}
//               </thead>

//               <tbody>
//                 {rows.length === 0 ? (
//                   <tr><td colSpan={columns.length}>No Records Found</td></tr>
//                 ) : (
//                   rows.map((row, rowIdx) => (
//                     <tr
//                       key={row.id}
//                       onMouseEnter={() => setHoveredRow(rowIdx)}
//                       onMouseLeave={() => setHoveredRow(null)}
//                     >
//                       {row.getVisibleCells().map((cell, ci) => {
//                         const isLast = ci === row.getVisibleCells().length - 1;
//                         const colId = cell.column.columnDef.accessorKey;
//                         const isNum = numericColIds.has(colId);
//                         const isSlNo = cell.column.id === "slNo";
//                         const metaAlign = cell.column.columnDef.meta?.style?.textAlign;
//                         const resolvedAlign = metaAlign ? metaAlign : isNum ? "right" : "left";

//                         // ✅ NEW: check for color property
//                         const bgStyle = cell.column.columnDef.color
//                           ? { backgroundColor: cell.column.columnDef.color, textAlign: resolvedAlign }
//                           : { textAlign: resolvedAlign };

//                         return (
//                           <td key={cell.id} style={bgStyle}>
//                             {cell.column.columnDef.cell
//                               ? formatValue(cell.column.columnDef.cell(cell.getContext()))
//                               : formatValue(cell.getValue())}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   ))
//                 )}
//               </tbody>

//               {showFooter && rows?.length !== 0 && (
//                 // <tfoot className="newreporttable-foot">
//                 //   <tr>
//                 //     {columns.map((col, index) => {
//                 //       const isLast = index === columns.length - 1;
//                 //       const isLabel = col.Footer === "Total";
//                 //       return (
//                 //         <td key={index} >
//                 //           {!col.Footer ? "" : isLabel ? "Total" : rowsCount(col)}
//                 //         </td>
//                 //       );
//                 //     })}
//                 //   </tr>
//                 // </tfoot>

//                 // <tfoot className="newreporttable-foot">
//                 //   <tr>
//                 //     {table.getAllLeafColumns().map(col => {
//                 //       const def = col.columnDef;
//                 //       let content = "";

//                 //       if (typeof def.Footer === "function") {
//                 //         content = flexRender(def.Footer, { table });
//                 //       } else if (def.Footer === "Total") {
//                 //         content = "Total";
//                 //       } else if (def.Footer === true) {
//                 //         content = rowsCount(def); // your helper
//                 //       }

//                 //       return <td key={col.id}>{content}</td>;
//                 //     })}
//                 //   </tr>
//                 // </tfoot>
//                 <tfoot className="newreporttable-foot">
//                   <tr>
//                     {table.getAllLeafColumns().map(col => {
//                       const def = col.columnDef;

//                       // ✅ Apply background + text colors if defined
//                       const style = {
//                         ...(def.color ? { backgroundColor: def.color } : {}),
//                         ...(def.textColor ? { color: def.textColor } : {}),
//                         textAlign: "center",   // keep footer values centered
//                         fontWeight: "bold"     // make totals stand out
//                       };

//                       let content = "";
//                       if (typeof def.Footer === "function") {
//                         content = flexRender(def.Footer, { table });
//                       } else if (def.Footer === "Total") {
//                         content = "Total";
//                       } else if (def.Footer === true) {
//                         content = rowsCount(def);
//                       }

//                       return (
//                         <td key={col.id} style={style}>
//                           {content}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 </tfoot>





//               )}
//             </table>
//           </div>

//           {/* Pagination */}
//           {showPagination && (
//             <div className="crt-pagination">
//               <button

//                 onClick={() => table.previousPage()}
//                 disabled={!table.getCanPreviousPage()}

//               ><GrFormPrevious /></button>
//               <span>
//                 Page <strong >{pageIndex + 1}</strong> of{" "}
//                 <strong >{table.getPageCount()}</strong>
//               </span>
//               <button

//                 onClick={() => table.nextPage()}
//                 disabled={!table.getCanNextPage()}

//               ><GrFormNext /></button>
//             </div>
//           )}

//         </div>
//       </div >
//     </>
//   );
// }








import React, { useState, useRef, useEffect } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { FaFileExcel, FaPrint, FaSearch } from "react-icons/fa";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";
// ─── Design tokens ────────────────────────────────────────────────────────────
const T = {
  brown: "#5c3d11",
  brownDark: "#3e2005",
  orange: "#e07b2a",
  bgHead: "#f0f4f8",    // clean cool-grey thead
  borderHead: "#dde4ec",
  borderCell: "#eef2f7",
  textHead: "#3a5a7a",    // slate blue-grey header labels
  textCell: "#1a1a1a",
  rowHover: "#fdf6ee",
  footerBg: "#faf3eb",    // dark brown — matches header
  footerText: "#201403",    // warm gold text on brown
  font: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
};

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS = `



  @media print {
    .crt-toolbar, .crt-pagination { display: none !important; }
    .crt-card { box-shadow: none !important; border: none !important; }
    thead tr th {
      background-color: ${T.brownDark} !important;
      color: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

function InjectStyles() {
  useEffect(() => {
    const id = "crt-styles-v4";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = CSS;
      document.head.appendChild(el);
    }
  }, []);
  return null;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function isNumericValue(val) {
  if (val === null || val === undefined || val === "") return false;
  return !isNaN(Number(val)) && String(val).trim() !== "";
}
function isNumericColumn(data, accessorKey) {
  if (!accessorKey) return false;
  const s = data.filter(r => r[accessorKey] != null).slice(0, 3);
  return s.length > 0 && s.every(r => isNumericValue(r[accessorKey]));
}


// ─── Component ────────────────────────────────────────────────────────────────
export default function CommonReactTable({
  columns, data, headerName,
  showPagination = true,
  showFooter = "false",
  align = "right",
  decimal,
  showPrint = true,
  showExcel = true,
  excelFileName,
  stickyHeader = false,
  stickyHeight = "60vh",

}) {
  const [globalFilter, setGlobalFilter] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: showPagination ? 10 : (data?.length || 0),
  });


  useEffect(() => {
    if (!showPagination) {
      setPagination((prev) => ({
        ...prev,
        pageSize: data?.length || 0,
      }));
    }
  }, [data, showPagination]);
  const table = useReactTable({
    data, columns,

    state: { globalFilter, pagination },
    onPaginationChange: setPagination,


    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const rows = table.getRowModel().rows;
  const { pageIndex, pageSize } = pagination;
  const tableRef = useRef(null);

  const handlePrint = useReactToPrint({ contentRef: tableRef, documentTitle: excelFileName });

  // ─── FIXED handleExcelExport ───────────────────────────────────────────────
  // Handles: flat columns, grouped/nested columns, with or without footer totals
  const handleExcelExport = () => {
    const headerGroups = table.getHeaderGroups();        // all header levels
    const leafCols = table.getVisibleLeafColumns();  // final data columns
    const dataRows = table.getRowModel().rows;       // visible (filtered) rows
    const maxDepth = headerGroups.length;            // number of header rows
    const colCount = leafCols.length;

    // ── Step 1: Build 2-D header matrix with correct rowSpan + colSpan ───────
    // Track occupied cells so rowSpan-extended cells stay blank
    const occupied = Array.from({ length: maxDepth }, () => new Array(colCount).fill(false));
    const headerMatrix = Array.from({ length: maxDepth }, () => new Array(colCount).fill(""));
    const merges = [];

    headerGroups.forEach((group, rowIdx) => {
      let colCursor = 0;

      group.headers.forEach((header) => {
        // skip columns already claimed by a rowSpan from a row above
        while (colCursor < colCount && occupied[rowIdx][colCursor]) colCursor++;

        const colSpan = header.colSpan || 1;

        // leaf header (no children) → spans all remaining depth rows downward
        // parent header (has children) → spans only 1 row
        const isLeaf = !header.subHeaders || header.subHeaders.length === 0;
        const rowSpan = header.isPlaceholder ? 1 : (isLeaf ? maxDepth - rowIdx : 1);

        const label = header.isPlaceholder
          ? ""
          : typeof header.column.columnDef.header === "string"
            ? header.column.columnDef.header
            : header.column.id;

        if (!header.isPlaceholder) {
          headerMatrix[rowIdx][colCursor] = label;
        }

        // mark every cell covered by this span as occupied
        for (let r = rowIdx; r < rowIdx + rowSpan; r++) {
          for (let c = colCursor; c < colCursor + colSpan; c++) {
            if (r !== rowIdx || c !== colCursor) occupied[r][c] = true;
          }
        }

        // register Excel merge when span covers more than one cell
        if (colSpan > 1 || rowSpan > 1) {
          merges.push({
            s: { r: rowIdx, c: colCursor },
            e: { r: rowIdx + rowSpan - 1, c: colCursor + colSpan - 1 },
          });
        }

        colCursor += colSpan;
      });
    });

    // ── Step 2: Data rows (keep numbers as JS numbers so Excel can SUM) ──────
    const bodyRows = dataRows.map((row, i) =>
      leafCols.map((col) => {
        if (col.id === "slNo") return i + 1;

        const getCellValueForExport = () => {
          if (typeof col.columnDef.cell !== "function") return "";
          try {
            const cellCtx = row.getVisibleCells().find((c) => c.column.id === col.id)?.getContext() || { row, getValue: () => undefined };
            const result = col.columnDef.cell(cellCtx);
            if (result === null || result === undefined) return "";
            if (typeof result === "number" || typeof result === "string") return result;
            if (result?.props?.children !== undefined) return result.props.children;
            return "";
          } catch {
            return "";
          }
        };

        const valueFromAccessor = row.getValue(col.id);
        const resolved = (valueFromAccessor === null || valueFromAccessor === undefined || valueFromAccessor === "")
          ? getCellValueForExport()
          : valueFromAccessor;

        if (resolved === null || resolved === undefined || resolved === "") return "";
        const asNum = Number(resolved);
        return isNaN(asNum) ? resolved : asNum;
      })
    );

    // ── Step 3: Footer row ────────────────────────────────────────────────────
    const footerRow = leafCols.map((col) => {
      const def = col.columnDef;
      if (!def.Footer) return "";
      if (def.Footer === "Total") return "Total";

      // Footer as function (may return JSX like <strong>{total}</strong>)
      if (typeof def.Footer === "function") {
        try {
          const result = def.Footer({ table });
          if (result === null || result === undefined) return "";
          if (typeof result === "number" || typeof result === "string") return result;
          // unwrap JSX primitives: <strong>1234</strong> → 1234
          if (result?.props?.children !== undefined) return result.props.children;
          return "";
        } catch {
          return "";
        }
      }

      // Footer === true → use rowsCount helper (accessorKey-based sum)
      if (def.Footer === true) {
        return rowsCount(def);
      }

      return "";
    });

    const hasFooter = footerRow.some((v) => v !== "");

    // ── Step 4: Assemble final array-of-arrays ────────────────────────────────
    const aoa = [
      ...headerMatrix,
      ...bodyRows,
      ...(hasFooter ? [footerRow] : []),
    ];

    // ── Step 5: Build worksheet + apply merges + auto column widths ───────────
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!merges"] = merges;

    const colWidths = Array(colCount).fill(10);
    aoa.forEach((row) => {
      row.forEach((cell, c) => {
        const len = String(cell ?? "").length;
        if (len > colWidths[c]) colWidths[c] = len;
      });
    });
    ws["!cols"] = colWidths.map((w) => ({ wch: Math.min(w + 2, 40) }));

    // ── Step 6: Write file ────────────────────────────────────────────────────
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${excelFileName || "export"}.xlsx`);
  };
  // ──────────────────────────────────────────────────────────────────────────


  function rowsCount(col) {
    let sum = 0;
    const rdata = data; // use all rows
    if (col?.FooterParamAction) {
      const p = col.Footerparams?.split("-");
      const p1 = rdata?.reduce((s, r) => s + (Number(r[p[0]]) || 0), 0);
      const p2 = rdata?.reduce((s, r) => s + (Number(r[p[1]]) || 0), 0);
      const p3 = rdata?.reduce((s, r) => s + (Number(r[p[2]]) || 0), 0);
      if (col.FooterParamAction === "-") sum = p1 - p2 - p3;
      else if (col.FooterParamAction === "/") sum = parseFloat(((p1 / p2) * 100).toFixed(1));
      else sum = p1 + p2;
    } else {
      sum = rdata?.reduce((s, r) => s + (Number(r[col.accessorKey]) || 0), 0);
    }
    return !isNaN(sum) ? (decimal === "two" ? sum.toFixed(2) : sum) : "";
  }

  const totalRows = table.getFilteredRowModel().rows.length;
  const allHeaders = table.getHeaderGroups();



  function getLeafColumns(cols) {
    let leaf = [];

    cols.forEach(col => {
      if (col.columns) {
        leaf = leaf.concat(getLeafColumns(col.columns));
      } else {
        leaf.push(col);
      }
    });

    return leaf;
  }

  const leafColumns = getLeafColumns(columns);

  const numericColIds = new Set(
    leafColumns
      .filter(col => col.accessorKey && isNumericColumn(data, col.accessorKey))
      .map(col => col.accessorKey)
  );
  const formatValue = (val) => {
    if (val === null || val === undefined || val === "") {
      return "-";
    }
    return val;
  };

  const tableResponsiveClassName = stickyHeader
    ? "table-responsive crt-table-responsive--sticky"
    : "table-responsive";

  const tableResponsiveStyle = stickyHeader
    ? { "--crt-sticky-height": typeof stickyHeight === "number" ? `${stickyHeight}px` : stickyHeight }
    : undefined;

  const cardClassName = stickyHeader ? "crt-card crt-card--sticky-header" : "crt-card";

  return (
    <>
      <InjectStyles />
      <div>
        <div className={cardClassName}>

          <div
            className="crt-toolbar"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              className="crt-toolbar-right mb-2"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                className="search-container"

              >
                <FaSearch className="crt-search-icon" style={{ marginRight: "6px" }} />
                <input
                  value={globalFilter ?? ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Search..."
                  className="crt-search"
                  style={{
                    border: "none",
                    outline: "none",
                  }}
                />
              </div>

              {showExcel && (
                <button
                  type="button"
                  className="print-tablebtn btn-success btn btn-sm"
                  onClick={handleExcelExport}
                >
                  <FaFileExcel size={14} />
                </button>
              )}

              {showPrint && (
                <button
                  type="button"
                  className="print-tablebtn btn-primary btn btn-sm"
                  onClick={handlePrint}
                >
                  <FaPrint size={14} />
                </button>
              )}
            </div>
          </div>


          {/* Table */}
          <div className={tableResponsiveClassName} style={tableResponsiveStyle}>
            <table ref={tableRef} className="newreporttable table table-bordered table-hovered  ">



              <thead>
                {table.getHeaderGroups().map(headerGroup => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => (
                      <th key={header.id} colSpan={header.colSpan}>
                        {header.isPlaceholder
                          ? null
                          : flexRender(header.column.columnDef.header, header.getContext())}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr><td
                    colSpan={columns.length}
                    style={{ textAlign: "center", color: "red", fontWeight: "bold" }}
                  >
                    ** No Records Found **
                  </td></tr>
                ) : (
                  rows.map((row, rowIdx) => (
                    <tr
                      key={row.id}
                      onMouseEnter={() => setHoveredRow(rowIdx)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      {row.getVisibleCells().map((cell, ci) => {
                        const isLast = ci === row.getVisibleCells().length - 1;
                        const colId = cell.column.columnDef.accessorKey;
                        const isNum = numericColIds.has(colId);
                        const isSlNo = cell.column.id === "slNo";
                        const metaAlign = cell.column.columnDef.meta?.style?.textAlign;
                        const resolvedAlign = metaAlign ? metaAlign : isNum ? "right" : "left";

                        // ✅ NEW: check for color property
                        const bgStyle = cell.column.columnDef.color
                          ? { backgroundColor: cell.column.columnDef.color, textAlign: resolvedAlign }
                          : { textAlign: resolvedAlign };

                        return (
                          <td key={cell.id} style={bgStyle}>
                            {cell.column.columnDef.cell
                              ? formatValue(cell.column.columnDef.cell(cell.getContext()))
                              : formatValue(cell.getValue())}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                )}
              </tbody>

              {showFooter && rows?.length !== 0 && (
                <tfoot className="newreporttable-foot">
                  <tr>
                    {table.getAllLeafColumns().map(col => {
                      const def = col.columnDef;

                      // ✅ Apply background + text colors if defined
                      const style = {
                        ...(def.color ? { backgroundColor: def.color } : {}),
                        ...(def.textColor ? { color: def.textColor } : {}),
                        textAlign: "center",   // keep footer values centered
                        fontWeight: "bold"     // make totals stand out
                      };

                      let content = "";
                      if (typeof def.Footer === "function") {
                        content = flexRender(def.Footer, { table });
                      } else if (def.Footer === "Total") {
                        content = "Total";
                      } else if (def.Footer === true) {
                        content = rowsCount(def);
                      }

                      return (
                        <td key={col.id} style={style}>
                          {content}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </table>
          </div>

          {/* Pagination */}
          {showPagination && (
            <div className="crt-pagination">
              <button

                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}

              ><GrFormPrevious /></button>
              <span>
                Page <strong >{pageIndex + 1}</strong> of{" "}
                <strong >{table.getPageCount()}</strong>
              </span>
              <button

                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}

              ><GrFormNext /></button>
            </div>
          )}

        </div>
      </div >
    </>
  );
}




